import React from 'react';
import HomepageContentManager from 'components/UI/adminPage/homepageContent/HomepageContentManager';
import 'styles/css/homepage-content-admin.css';

function HomepageContentPage() {
  return (
    <div className="homepage-content-admin-page">
      <HomepageContentManager />
    </div>
  );
}

export default HomepageContentPage;
